import {
  Block,
  PartialBlock,
  BlockNoteSchema,
  createHeadingBlockSpec,
  defaultBlockSpecs,
} from '@blocknote/core';

const heading = createHeadingBlockSpec({
  allowToggleHeadings: false,
  levels: [1, 2, 3],
});

export const schema = BlockNoteSchema.create({
  blockSpecs: {
    heading,
    paragraph: defaultBlockSpecs.paragraph,
    bulletListItem: defaultBlockSpecs.bulletListItem,
    numberedListItem: defaultBlockSpecs.numberedListItem,
  },
});

export const blockTypes = [
  'heading',
  'paragraph',
  'bulletListItem',
  'numberedListItem',
] as const;

export type TextBlockSchema = typeof schema.blockSchema;
export type TextBlock = Block<TextBlockSchema>;
export type PartialTextBlock = PartialBlock<TextBlockSchema>;
export type BlockNoteDocument = Array<PartialTextBlock>;
